import { render, staticRenderFns } from "./sourceMarket.vue?vue&type=template&id=bbf3ca82&scoped=true&"
import script from "./sourceMarket.vue?vue&type=script&lang=js&"
export * from "./sourceMarket.vue?vue&type=script&lang=js&"
import style0 from "./sourceMarket.vue?vue&type=style&index=0&id=bbf3ca82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf3ca82",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/supplier/sourceMarket.vue
// module id = null
// module chunks = 